(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-tabs]').forEach(function(wrapper){

  const tabs = wrapper.querySelectorAll('.custom-tab');
  const contents = wrapper.querySelectorAll('.custom__tab-content');
  const headers = wrapper.querySelectorAll('.accordion-header');

  /* DESKTOP TABS */
  tabs.forEach(function(tab){
    tab.addEventListener('click', function(){
      const id = this.dataset.contentId;

      contents.forEach(c => c.classList.remove('active'));
      tabs.forEach(t => t.classList.remove('active'));

      this.classList.add('active');
      wrapper.querySelector('#' + id).classList.add('active');
    });
  });

  /* MOBILE ACCORDION */
  headers.forEach(function(header){
    header.addEventListener('click', function(){
      const parent = this.parentElement;
      if(parent.classList.contains('active')){
        parent.classList.remove('active');
      } else {
        contents.forEach(c => c.classList.remove('active'));
        parent.classList.add('active');
      }
    });
  });

});

  } catch(e) { console.error(e); }
})();
})();
